import { NgModule }             		  	        from '@angular/core';
import { RouterModule, Routes } 		  	        from '@angular/router';

import { AuthGuard }                            from './_guards';

import { LoginComponent }      			  	        from './login/login.component';
import { AuthComponent }                        from './login/auth.component';
import { DashboardComponent }         		      from './dashboard/dashboard.component';
import { ProctorComponent }           		      from './proctor/proctor.component';
import { StudentlistComponent }           	    from './report/studentlist.component';
import { ExamlistComponent }           		      from './examlist/examlist.component';
import { ReportComponent }           		        from './report/report.component';
import { VivalistComponent }           		      from './viva/vivalist.component';
import { ClientviewComponent }                  from './clientview/clientview.component';
import { ExamLinkComponent }                    from './exam-link/exam-link.component';
import { VideosComponent }                      from './videos/videos.component';
import { PracticalComponent }                   from './practical/practical.component';
import { LivefeedComponent }                   from './proctor/livefeed.component';

const routes: Routes = [
    { path: '', redirectTo: '/login', pathMatch: 'full' },
	  { path: 'login', component: LoginComponent },
    { path: 'admin-login/:username/:user_id', component: AuthComponent },
    { path: 'client-login/:exam_id/:username/:contact', component: ClientviewComponent },
    { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
    { path: 'proctor-view/:type', component: ProctorComponent },
    { path: 'students', component: StudentlistComponent },
    { path: 'exams', component: ExamlistComponent, canActivate: [AuthGuard] },
    { path: 'videos', component: VideosComponent, canActivate: [AuthGuard] },
    { path: 'report', component: ReportComponent, canActivate: [AuthGuard] },
    { path: 'viva/:id', component: VivalistComponent, canActivate: [AuthGuard] },
    { path: 'exams-link/:batch_id', component: ExamLinkComponent },
    { path: 'practical/:id', component: PracticalComponent },
    { path: 'livefeed', component: LivefeedComponent },


    
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}